import * as React from "react";

function SvgStar(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 .5l1.81 4.508 4.847.329L9.93 8.452l1.185 4.711L7 10.58l-4.114 2.583L4.07 8.452.343 5.337l4.847-.329L7 .5z"
        fill="#F1C34D"
      />
    </svg>
  );
}

export default SvgStar;
